/**
 * 注意：执行compile命令会重新生成本文件，所以请不要修改本文件
 */
import { translate, VoerkaI18nScope } from '@voerkai18n/runtime';
import idMap from './idMap'; // 语言ID映射文件
import defaultFormatters from './formatters/zh'; // 默认语言格式化器
import defaultMessages from './zh';

const messages = {
  zh: defaultMessages,
  cht: () => import('./cht'),
  en: () => import('./en'),
};

const formatters = {
  zh: defaultFormatters,
  cht: () => import('./formatters/cht'),
  en: () => import('./formatters/en'),
};

// 语言配置文件
const scopeSettings = {
  languages: [
    {
      name: 'zh',
      title: '中文',
    },
    {
      name: 'cht',
      title: '繁体中文',
    },
    {
      name: 'en',
      title: '英语',
    },
  ],
  defaultLanguage: 'zh',
  activeLanguage: 'zh',
  namespaces: {},
};

// 语言作用域
const scope = new VoerkaI18nScope({
  id: 'wisdom_ib_sass_web', // 当前作用域的id，自动取当前工程的package.json的name
  debug: false, // 是否在控制台输出调试信息
  idMap, // 消息id映射列表
  library: false, // 开发库时设为true
  messages, // 语言包
  formatters, // 扩展自定义格式化器
  storage: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    get() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    remove() {},
  }, // 语言配置存储器
  ...scopeSettings,
});

// 翻译函数
const tIgnore = (msg: string) => msg;

const scopedTranslate = translate.bind(scope);

export type TType = typeof scopedTranslate;

export type TIgnoreType = typeof tIgnore;

export { scopedTranslate as t, scope as i18nScope, tIgnore };

export default { t: scopedTranslate, i18nScope: scope, tIgnore };
